// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TmWl3","content":"styles_content__MXn5b","row":"styles_row__3Ty4k","footer":"styles_footer__2uxxI","phraseLength":"styles_phraseLength__LKR0U"};